'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  view: 'details',
  vehicle: {
    regNo: 'PJ63LXR',
    regDate: {
      year: 2013,
      month: 12,
      day: 5,
      dayOfWeek: 'Thursday',
      hour: 0,
      minute: 0,
      second: 0
    },
    abiCode: '52123803',
    manufacturer: 'VAUXHALL',
    shortModelName: 'CORSA',
    fullModelName: 'CORSA SXI',
    shortDerivative: '5dr, 2011',
    fullDerivative: '1398cc, Petrol, 5dr, Manual, 2011',
    description: '2011-2014, VAUXHALL, CORSA SXI, Manual, 1.4 litre, Petrol, 5 door',
    trim: 'SXI',
    body: '',
    doors: 5,
    trans: 'Manual',
    fuel: 'Petrol',
    manufacturedFromYear: 2011,
    manufacturedToYear: 2014,
    cc: 1398,
    litre: '1.4',
    seats: 4,
    abiGroup: 8,
    bodyCode: '02',
    fuelCode: '002',
    transCode: '002',
    manuDate: {
      year: 2013,
      month: 12,
      day: 5,
      dayOfWeek: 'Thursday',
      hour: 0,
      minute: 0,
      second: 0
    },
    valuation: {
      mileage: 60000,
      forecourtValue: 4190,
      privateValue: 4010,
      auctionValue: 3610
    }
  },
  // reg lookup
  cdlOptions: [],
  cdlFetching: false,
  cdlError: false,
  // manual lookup
  manualError: false,
  manualOptions: {
    manufacturerOptions: [],
    modelOptions: [],
    transOptions: [],
    fuelOptions: [],
    engineOptions: [],
    trimOptions: [],
    doorsOptions: [],
    yearOptions: []
  },
  manualFetching: {
    manufacturerOptions: false,
    modelOptions: false,
    transOptions: false,
    fuelOptions: false,
    engineOptions: false,
    trimOptions: false,
    doorsOptions: false,
    yearOptions: false
  }
};